import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { UitkSeatMapCabinLayout } from './uitk-seat-map-cabin-layout.esm.js';
import { UitkSeatMapCabin } from './uitk-seat-map-cabin.esm.js';
import styles from './uitk-seat-map.css';

var getClassNameList = classNames.bind(styles);
var UitkSeatMap = function (_a) {
    var seatMapResult = _a.seatMapResult, onSeatButtonClickCB = _a.onSeatButtonClickCB, seatConfirmedDetails = _a.seatConfirmedDetails, seatSelected = _a.seatSelected, rowIndexRef = _a.rowIndexRef;
    var cabinDimensionDetails = seatMapResult.cabinDimensionDetails;
    if (seatMapResult.seatMapRows && seatMapResult.seatMapRows[0].seatMapRowSeats) {
        return (React.createElement("div", { className: getClassNameList('uitk-seat-map') },
            React.createElement(UitkSeatMapCabinLayout, { seatMapCabinDimensionDetails: cabinDimensionDetails },
                React.createElement(UitkSeatMapCabin, { seatRows: seatMapResult === null || seatMapResult === void 0 ? void 0 : seatMapResult.seatMapRows, onSeatButtonClickCB: onSeatButtonClickCB, seatConfirmedDetails: seatConfirmedDetails, seatSelected: seatSelected, rowIndexRef: rowIndexRef !== null && rowIndexRef !== void 0 ? rowIndexRef : 0, maxColumns: cabinDimensionDetails.columnsCount }))));
    }
    return null;
};
UitkSeatMap.displayName = 'UitkSeatMap';

export { UitkSeatMap };
